/** Possible placements of the OAI button on the learn page. */
export enum OaiPlacement {
  HEADER = 'header',
  VIDEO = 'video',
}

/**
 * Shape of the `/api/learnPageABTest` response. Currently empty (no active
 * learn-page A/B tests) — extend with one field per active test (e.g.
 * `foo: FooVariant`) when a resolver is added.
 */
export type LearnABTestData = Record<string, never>;

/** Default response when no test buckets the visitor. */
export const LEARN_AB_TEST_DEFAULT: LearnABTestData = {};
/** A/B test name persisted in `ab_test_users`. */
export const LEARN_PAGE_VERSION_TEST = 'learn-page-version';
